import { imageUrlZodType } from "@@/shared/images/image-url";
import { z } from "zod";
import { imageReferenceZodObject } from "../images/image-reference";
import { storageItemImageReferenceZodObject } from "../storage-items/storage-item-images/storage-item-image-reference";

const metaImageZodSchema = z.union([
    imageReferenceZodObject,
    storageItemImageReferenceZodObject,
    imageUrlZodType,
]);
type MetaImage = z.infer<typeof metaImageZodSchema>;

export { metaImageZodSchema };
export type { MetaImage };
